import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: "login",
      path: "/login",
      component: () => import("@/view/pages/auth/login_pages/Login-1"),
    },
    {
      path: "/",
      redirect: "/PlansTable",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/erp/dashboard/Dashboard"),
        },
        {
          path: "/PlansTable",
          name: "PlansTable",
          component: () => import("@/view/erp/plans/PlansTable"),
        },
        {
          path: "/PlansAll",
          name: "PlansAll",
          component: () => import("@/view/erp/plans/PlansAll"),
        },
        {
          path: "/PlansAll/:id",
          name: "PlansAll2",
          component: () => import("@/view/erp/plans/PlansAll"),
        },
        {
          path: "/Config/Company",
          name: "ConfigCompany",
          component: () => import("@/view/erp/config/Company"),
        },
        {
          path: "/Config/Building",
          name: "ConfigBuilding",
          component: () => import("@/view/erp/config/Building"),
        },
        {
          path: "/Config/Contact",
          name: "ConfigContact",
          component: () => import("@/view/erp/config/Contact"),
        },
        {
          path: "/Config/Team",
          name: "ConfigTeam",
          component: () => import("@/view/erp/config/Team"),
        },
        {
          path: "/Config/User",
          name: "ConfigUser",
          component: () => import("@/view/erp/config/User"),
        },
        {
          path: "/Config/Contract",
          name: "Contract",
          component: () => import("@/view/erp/config/Contract"),
        },
      ]
    }
  ],
})

router.beforeEach((to, from, next) => {
  if(to?.path != '/login') {
    let user_data = localStorage.getItem('user_data')
    user_data = JSON.parse(user_data)
    if (user_data?.active) {
      next()
    } else {
      from?.path == '/login' ? next()  : next('/login') 
    }
  } else {
    localStorage.removeItem('user_data')
    next()
  }
})

export default router
